// extracted by mini-css-extract-plugin
module.exports = {"fullBackgroundLayer":"FullBackgroundLayer-module__fullBackgroundLayer___29IU7"};